import React from 'react'

interface Props {
    text: string
}
class LoadingCover extends React.Component<Props> {
    public static defaultProps = {
        text: 'Loading…',
    }

    public render() {
        return (
            <div className="cover cover-loading">
                <big>
                    <span className="fa fa-pulse fa-spinner fa-fw" /> {this.props.text}
                </big>
            </div>
        )
    }
}

export default LoadingCover
